
import {Component, Vue} from 'vue-property-decorator'
import MaterialSelect from "@/components/material-select/index.vue";
import {apiNewsAdd, apiNewsDetail, apiNewsEdit, apiShopLists} from '@/api/shop'
import {debounce} from '@/utils/util'

@Component({
  components: {
    MaterialSelect,
  }
})
export default class NewsEdit extends Vue {
  identity: number | null = null;
  shopData: any[] = []
  form: any = {
    // title: '',
    image: '',
    content: '',
    type: 2 // type=2表示资讯
  };

  rules = {
    sid: [{required: true, message: '请选择商城', trigger: ['blur', 'change']}],
    image: [{required: true, message: '请上传封面图', trigger: ['blur', 'change']}],
    content: [{required: true, message: '请输入内容', trigger: ['blur', 'change']}],
  };

  onSubmit(formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      if (!this.identity) {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    })
  }

  async handleAdd(): Promise<void> {
    await apiNewsAdd({...this.form})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async handleEdit(): Promise<void> {
    await apiNewsEdit({...this.form, id: this.identity})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async getDetailFunc(): Promise<void> {
    const res = await apiNewsDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  created() {
    const query: any = this.$route.query
    this.identity = +query.id
    if (+query.id) {
      this.getDetailFunc()
    }
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)
  }
}
